import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';
import { LeagueOutput } from '../../generated-api';
import { resolveLeagueIcon } from '../../utils/leagueIcon';

interface LeagueChipToggleProps {
  league: LeagueOutput;
  isSelected: boolean;
  isDisabled: boolean;
  onToggle: (leagueId: string) => void;
}

const LeagueChipToggle: React.FC<LeagueChipToggleProps> = ({
  league,
  isSelected,
  isDisabled,
  onToggle,
}) => {
  return (
    <button
      data-track="wizard_league_chip"
      type="button"
      onClick={() => !isDisabled && onToggle(league.id)}
      disabled={isDisabled}
      className={`flex items-center gap-1.5 px-3 py-2 rounded-lg
                  border transition-all duration-150
                  min-h-[44px] shrink-0
                  active:scale-[0.97]
                  motion-reduce:active:scale-100
                  ${isSelected
                    ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20 text-primary-900 dark:text-primary-200'
                    : 'border-edge bg-surface text-body hover:bg-surface-hover'
                  }
                  ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      aria-pressed={isSelected}
    >
      <span className="text-lg shrink-0">
        {resolveLeagueIcon(league.icon, league.isGlobal ? '🌍' : '🏆')}
      </span>
      <span className="text-sm font-medium truncate max-w-[80px]">{league.name}</span>
      {isSelected && (
        <CheckIcon className="w-3.5 h-3.5 text-primary-500 shrink-0" strokeWidth={2.5} />
      )}
    </button>
  );
};

export default LeagueChipToggle;
